<template>
  <v-app-bar elevation="1" density="comfortable">
    <v-container fluid class="d-flex align-center pa-0" style="max-width: 100%; padding-left: 16px !important; padding-right: 48px !important;">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" class="app-logo" viewBox="0 0 1639 512" style="height: 32px; width: auto;" role="img" :aria-label="$t('a11y.appLogo')">
          <path opacity=".4" d="M694.6 295.9c0 67.6 54.3 121.9 121.9 121.9c21.5 0 43-6.1 60.4-16.4l1 1c9.2-5.1 9.2-17.4 2-25.6L736.6 233.5c-7.2-8.2-20.5-7.2-25.6 2c-10.2 17.4-16.4-7.2-16.4 60.4zM754 216.1L897.3 359.4c8.2 7.2 20.5 7.2 25.6-2c10.2-17.4 16.4-38.9 16.4-60.4c0-67.6-54.3-121.9-121.9-121.9l-1-1c-22.5 0-43 6.1-60.4 16.4c-9.2 5.1-10.2 18.4-2 25.6z"/>
          <path d="M48.4 298v119.8H.3V298c0-32.8 11.3-61.4 34.8-85s52.2-34.8 85-34.8v48.1c-19.5 0-36.9 7.2-51.2 21.5S47.4 278.5 47.4 299zm269.3 48.1h57.3c-6.1 13.3-14.3 25.6-25.6 36.9c-23.6 23.6-52.2 34.8-85 34.8s-61.4-11.3-85-34.8-34.8-52.2-34.8-85 11.3-61.4 34.8-85 52.2-34.8 85-34.8 61.4 11.3 85 34.8 34.8 52.2 34.8 85 0 16.4-2 23.6H195.9c3.1 10.2 9.2 18.4 17.4 26.6c14.3 14.3 30.7 21.5 51.2 21.5s36.9-7.2 51.2-21.5 2-2 3.1-3.1zm14.3-72.7c-3.1-10.2-9.2-18.4-17.4-26.6c-14.3-14.3-30.7-21.5-51.2-21.5s-36.9 7.2-51.2 21.5-13.3 17.4-17.4 26.6h136.2zM407.9 81.9H456v96.3h71.7v48.1H456V298c0 19.5 7.2 36.9 21.5 51.2s30.7 21.5 51.2 21.5v48.1c-32.8 0-61.4-11.3-85-34.8s-34.8-52.2-34.8-85V81.9zM600.4 298v119.8h-48.1V298c0-32.8 11.3-61.4 34.8-85s52.2-34.8 85-34.8v48.1c-19.5 0-36.9 7.2-51.2 21.5s-21.5 30.7-21.5 51.2zm563.2 96.3c-20.5 15.4-45.1 23.6-71.7 23.6s-61.4-11.3-85-34.8-34.8-52.2-34.8-85 11.3-61.4 34.8-85 52.2-34.8 85-34.8 61.4 11.3 85 34.8 34.8 52.2 34.8 85v119.8h-48.1v-23.6zm-72.7-167.9c-19.5 0-36.9 7.2-51.2 21.5s-21.5 30.7-21.5 51.2 7.2 36.9 21.5 51.2 30.7 21.5 51.2 21.5 36.9-7.2 51.2-21.5 21.5-30.7 21.5-51.2-7.2-36.9-21.5-51.2-30.7-21.5-51.2-21.5zm332.8 95.2h50.2c-4.1 22.5-15.4 43-32.8 60.4s-52.2 34.8-85 34.8-61.4-11.3-85-34.8-34.8-52.2-34.8-85 11.3-61.4 34.8-85 52.2-34.8 85-34.8 61.4 11.3 85 34.8c17.4 17.4 28.7 37.9 32.8 61.4h-50.2c-3.1-10.2-9.2-18.4-17.4-26.6c-14.3-14.3-30.7-21.5-51.2-21.5s-36.9 7.2-51.2 21.5-21.5 30.7-21.5 51.2 7.2 36.9 21.5 51.2 30.7 21.5 51.2 21.5 36.9-7.2 51.2-21.5 13.3-17.4 17.4-26.6zm75.8-239.6h48.1v96.3h71.7v48.1h-71.7V298c0 19.5 7.2 36.9 21.5 51.2s30.7 21.5 51.2 21.5v48.1c-32.8 0-61.4-11.3-85-34.8s-34.8-52.2-34.8-85V81.9z"/>
        </svg>
      </div>
      
      <v-spacer></v-spacer>
      
      <div class="d-flex align-center">
        <!-- Where this account's records live. Leftmost of the group because it
             is context rather than an action, and because it is the one item
             here that is always present — the pending-doses button comes and
             goes, and a badge that stayed put while its neighbour appeared
             would be the only thing in the bar that did. Renders nothing at all
             unless the location is actually known. -->
        <DataResidencyBadge v-if="user" />

        <!-- Results recorded away from the workstation (quick entry) land here
             with no dose against them. This is the half of that feature that
             makes the other half safe: a value captured on a phone and never
             seen again is a clinical problem, not a UX one. Silent when there
             is nothing waiting. -->
        <PendingDosesButton v-if="user" />

        <!-- User Avatar & Menu (matching Praxio) -->
        <v-menu
          v-model="userMenuOpen"
          :close-on-content-click="false"
          location="bottom end"
          offset="8"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-if="user"
              v-bind="props"
              variant="flat"
              :color="isDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgb(219, 234, 254)'"
              size="default"
              icon
              :class="['font-weight-regular', isDarkMode ? 'text-white' : 'text-primary']"
              style="width: 42px; height: 42px; font-size: 16px;"
              :title="user?.email || 'Account'"
              :aria-label="$t('a11y.userMenu')"
            >
              {{ userInitial }}
            </v-btn>
          </template>
          
          <v-card min-width="280" elevation="8">
            <v-card-text :class="['px-4 py-3', { 'border-b': !DEMO_MODE }]">
              <div class="text-body-1 font-weight-medium text-grey-darken-3">{{ displayName }}</div>
              <div class="text-body-2 text-grey-darken-1 text-truncate">{{ user?.email }}</div>
              <v-chip
                v-if="userRole"
                :color="roleColor"
                variant="outlined"
                size="small"
                class="mt-2"
              >
                {{ userRole }}
              </v-chip>
            </v-card-text>
            <!-- Hidden in the public demo build: "Back to Praxio" would
                 navigate the visitor out of the embed. -->
            <v-list v-if="!DEMO_MODE" density="compact" class="py-1">
              <v-list-item :href="`${praxioUrl}/account`">
                <template v-slot:prepend>
                  <v-icon icon="fa-solid fa-arrow-left" size="default" class="mr-3 text-grey-darken-1" aria-hidden="true"></v-icon>
                </template>
                <v-list-item-title class="text-body-2">{{ $t('buttons.backToPraxio') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-container>
    
  </v-app-bar>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'
  import { computed, ref, watch } from 'vue'
  import { useRouter } from 'vue-router'
  import { useAuth } from './composables/useAuth.js'
  import http from './http-common'
  import { useDarkMode } from './composables/useDarkMode.js'
  import { PRAXIO_URL } from './config/praxioUrl.js'
  import { DEMO_MODE } from '@demo/config'
  import PendingDosesButton from './components/common/PendingDosesButton.vue'
  import DataResidencyBadge from './components/common/DataResidencyBadge.vue'

  const { locale } = useI18n()
  const router = useRouter()
  const { user, signOut } = useAuth()

  const currentLocale = computed(() => locale.value)
  const praxioUrl = PRAXIO_URL
  
  const userMenuOpen = ref(false)
  
  // Dark mode (shared controller — see composables/useDarkMode.js).
  // Read-only here: the avatar button tints itself by theme.
  const { isDarkMode } = useDarkMode()
  
  // User data from API (includes correct role without stale claims)
  const userData = ref(null)
  
  // Fetch user data from API to get correct role
  const fetchUserData = async () => {
    if (!user.value) {
      userData.value = null
      return
    }
    
    try {
      const response = await http.get('/users/current')
      userData.value = response.data
    } catch (err) {
      console.error('❌ Retroact appBar: Failed to fetch user data:', err)
    }
  }
  
  // Watch for auth changes
  watch(user, (newVal) => {
    if (newVal) {
      fetchUserData()
    } else {
      userData.value = null
    }
  }, { immediate: true })
  
  // User role from API data (not from Firebase token)
  const userRole = computed(() => {
    const role = userData.value?.role
    if (!role) return null
    return role === 'editor' ? 'Editor' : 'Viewer'
  })
  
  // Role color matching Praxio
  const roleColor = computed(() => {
    if (!userRole.value) return ''
    return 'blue-darken-3'
  })
  
  // Display name from Firebase custom claims (available immediately)
  const displayName = computed(() => {
    // Use Firebase displayName from custom claims (from SSO)
    if (user.value?.displayName) {
      return user.value.displayName
    }
    
    // Fallback to custom claims fields
    if (user.value?.reloadUserInfo?.customAttributes) {
      try {
        const claims = JSON.parse(user.value.reloadUserInfo.customAttributes)
        if (claims.name) return claims.name
        if (claims.firstName && claims.lastName) {
          return `${claims.firstName} ${claims.lastName}`
        }
      } catch (e) {
        console.error('Failed to parse custom claims:', e)
      }
    }
    
    // Final fallback to API data
    const firstName = userData.value?.firstName || userData.value?.first_name
    const lastName = userData.value?.lastName || userData.value?.last_name
    
    if (firstName && lastName) {
      return `${firstName} ${lastName}`
    }
    if (firstName) {
      return firstName
    }
    return user.value?.email || 'User'
  })
  
  // Compute user initials for avatar (from displayName or custom claims)
  const userInitial = computed(() => {
    // Try to extract from display name
    const name = displayName.value
    if (name && name !== user.value?.email) {
      const parts = name.split(' ')
      if (parts.length >= 2) {
        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
      }
      return name.charAt(0).toUpperCase()
    }
    
    // Fallback to email
    if (user.value?.email) {
      return user.value.email.charAt(0).toUpperCase()
    }
    return 'U'
  })
</script>

<script>
export default {
  name: "appBar"
};
</script>

